import React from 'react';
import EnumKeyToText from "components/product-price/base/EnumKeyToText";


type Iprops = {
  orderInfo: any;
  enums: any;
  style?: any;
}

const CarSeriesInfo: React.FC<Iprops> = (props: any) => {
  const { orderInfo, enums, style } = props || {};
  return (
    <div style={style}>
      <div>{orderInfo?.veh_model_info?.brand_name}/{orderInfo?.veh_model_info?.series_name}/{orderInfo?.veh_model_info?.model_name}</div>
      <div>
        {orderInfo.veh_model_info.group_code}
        ｜ <EnumKeyToText data={orderInfo.veh_model_info} enums={enums} valueKey={'transmission_type'} nameSpace={'transmission_type'} />
        ｜ <EnumKeyToText data={orderInfo.veh_model_info} enums={enums} valueKey={'fuel_type'} nameSpace={'fule_type'} />
        ｜ {orderInfo.veh_model_info.passenger_no}座
        ｜ {orderInfo.veh_model_info.door_no}门
      </div>
    </div>
  )
}

export default CarSeriesInfo;